/* 提供给原生退出登录界面 */
<template>
  <div :class="$style.logout">
    <div :class="$style.content">
      <header>
        <span>账号注销</span>
        <img :src="`${$cdnLink}/wanXin/orangeTheme/fanhui.png`" alt :class="$style.fanhui" @click="cancel" />
      </header>
      <main>
        <div v-show="!step">
          <p>申请注销账号</p>
          <p>为保证您的账号安全，您提交的注销申请生效前，需要同时满足以下条件：</p>
          <p>1、账号处于安全状态：</p>
          <p>账号没有被盗、被封等风险；账号在最近1个月内无绑定、换绑或解绑手机号、无修改密码等敏感操作。</p>
          <p>2、账号无任何纠纷，包括投诉举报：</p>
          <p>本账号及通过本账号接入的第三方已无未完成的交易、无任何维持里完成的纠纷（包括但不限于投诉举报、被投诉举报等）。</p>
        </div>
        <div v-show="step == 1">
          <p>注销账号提醒</p>
          <p>账号一旦注销，您自愿承担其所可能的所有结果，包括但不限于如下结果：</p>
          <p>1、注销后，账号将无法登录</p>
          <p>账号无法登录本公司相关的游戏，您的实名信息、手机号等绑定关系将解除。</p>
          <p>2、注销后，账号信息将会清楚或匿名化处理：</p>
          <p>除按照相关法律规定应当保留一定期限的相关信息或数据外，该账号内所有的数据将会被删除。</p>
          <p>3、注销后，账号的全部权益将无法找回：</p>
          <p>账户内的礼包等将视为您资源放弃且无法继续使用。</p>
        </div>
        <div v-show="step == 2" :class="$style.verify">
          <p>请输入当前实名认证信息确认注销</p>
          <div :class="$style.inputWrap">
            <img :src="`${$cdnLink}/wanXin/orangeTheme/zhanghao.png`" alt />
            <input type="text" v-model.trim="id_card_name" placeholder="请输入姓名" />
          </div>
          <div :class="$style.inputWrap">
            <img :src="`${$cdnLink}/wanXin/orangeTheme/idcard.png`" alt />
            <input type="text" v-model.trim="id_card_num" placeholder="请输入身份证号" />
          </div>
        </div>

        <div :class="$style.btnGroup">
          <button :class="$style.cancel" @click="cancel">取消</button>
          <button :class="$style.backLogin" @click="writeOffConfirm">确认</button>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { registQuitGameFunction } from '@/bridge/AppJsBridge';
import { isPure } from '@/libs/utils';
import { writeOffApi } from '@/api/user';
import { setStorage, getStorage } from '@/libs/utils';

export default {
  name: '',
  data() {
    return {
      id_card_name: '',
      id_card_num: '',
      step: 0,
    };
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    async writeOffConfirm() {
      if (!this.step) {
        this.step = 1;
        return;
      }

      if (this.step == 1) {
        this.step = 2;
        return;
      }

      const user_id = getStorage('user_id');
      const appkey = getStorage('appkey');
      const access_token = getStorage('access_token');

      await writeOffApi({
        user_id,
        appkey,
        access_token,
        id_card_name: this.id_card_name,
        id_card_num: this.id_card_num,
      });
      // 清除微信登录凭证缓存，确保重新显示登录页面
      localStorage.removeItem('wechat_login_credential');
      localStorage.removeItem('wechatAccount');
      if (isPure()) {
        registQuitGameFunction(null);
      } else {
        location.reload();
      }
    },
  },
};
</script>

<style lang="scss" module>
@import '../../../assets/css/common';
.logout {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  box-sizing: border-box;
  .content {
    @include full-screen-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      > div {
        padding: 15px;
      }
      .verify {
        > p {
          text-align: center;
          font-size: 16px;
          padding: 10px 0;
          color: #ff7955;
        }
      }
      .inputWrap {
        position: relative;
        display: flex;
        border-bottom: 1px solid #ebebeb;
        margin: 0 22px 12px;
        padding: 6px 9px;
        > img {
          width: 13px;
          height: 15px;
          margin-right: 14px;
        }
        > input {
          border: none;
          font-size: 15px;
        }
        > span {
          position: absolute;
          right: 10px;
          width: 50px;
          text-align: center;
          border: none;
          font-size: 11px;
          color: #999999;
        }
        .retry {
          color: #ff5b58;
        }
      }
      .btnGroup {
        width: 100%;
        position: absolute;
        bottom: 0px;
        display: flex;
        justify-content: center;
        > button {
          border: none;
          outline: none;
          background-color: transparent;
          width: 125px;
          height: 35px;
          color: #ffffff;
          border-radius: 35px;
          margin: 0 10px;
          background-size: cover;
          font-size: 14px;
        }
        .cancel {
          background-color: #b1aba8;
        }
        .backLogin {
          background: linear-gradient(90deg, #ff3b36, #ff7955);
        }
      }
    }
  }
}
</style>
